import React from 'react';
import {
  BusIcon,
  HotelIcon,
  PlusCircleIcon,
  UsdIcon,
  InfoCircleIcon,
  MonitorIcon,
  ActiveIcon,
  ExpiredIcon,
  PlusIcon,
  DraftIcon,
  UserCogIcon,
} from '~svg';

export const TOUR_MANAGMENT_TABS = [
  {
    tabName: 'createTour',
    message: {
      title: 'profile.createTour',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass: 'col-4 px-0',
    icon: PlusIcon,
  },
  {
    tabName: 'underReviewing',
    message: {
      title: 'tour.underreviewing',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass: 'col-4 px-0',
    icon: DraftIcon,
  },
  {
    tabName: 'usersTours',
    message: {
      title: 'tour.userstours',
      comment: '',
      isCommentLocalization: false,
    },
    containerClass: 'col-4 px-0',
    icon: UserCogIcon,
  },
];

const svgVariant = 'svg-small svg-md-normal svg-sm-large svg-xs-large';
export const CREATE_TOURS_SUB_TABS = [
  {
    id: 'info',
    titleId: 'profile.Info',
    icon: <InfoCircleIcon color="white" variant={svgVariant} />,
  },
  {
    id: 'transportation',
    titleId: 'profile.transportation',
    icon: <BusIcon color="white" variant={svgVariant} />,
  },
  {
    id: 'inhabitancy',
    titleId: 'profile.inhabitancy',
    icon: <HotelIcon color="white" variant={svgVariant} />,
  },
  {
    id: 'facility',
    titleId: 'profile.facilities',
    icon: <PlusCircleIcon color="white" variant={svgVariant} />,
  },
  {
    id: 'pricing',
    titleId: 'profile.pricing',
    icon: <UsdIcon color="white" variant={svgVariant} />,
  },
  {
    id: 'preview',
    titleId: 'ticket.preview',
    icon: <MonitorIcon size={26} color="white" variant={svgVariant} />,
  },
];

export const USERS_TOURS_SUB_TABS = [
  {
    labelId: 'tour.usersalltours',
    icon: <InfoCircleIcon />,
    id: 'allTour',
    specificVariant: 'justify-content-start',
  },
  {
    labelId: 'tour.usersactivetours',
    icon: <ActiveIcon />,
    id: 'activeTour',
    specificVariant: 'justify-content-center',
  },
  {
    labelId: 'tour.usersexpiredtours',
    icon: <ExpiredIcon />,
    id: 'expiredTour',
    specificVariant: 'justify-content-end',
  },
];

export const REVIEW_FIELDS = [
  { fieldName: 'tourInfo', labelId: 'profile.Info' },
  { fieldName: 'images', labelId: 'tour.tourimages' },
  { fieldName: 'description', labelId: 'tour.description' },
  { fieldName: 'tourTransport', labelId: 'profile.transportation' },
  { fieldName: 'residency', labelId: 'profile.inhabitancy' },
  { fieldName: 'facilities', labelId: 'profile.facilities' },
];

export const DRAFT_TYPE_OPTION = [
  { name: '', label: 'tour.ordering' },
  { name: 'tourInfo.name.en', label: 'tour.basedTourName' },
  {
    name: 'tourInfo.destination.name.en',
    label: 'tour.basedNamePlace',
  },
];
